// utils/exportToExcel.js
import * as XLSX from "xlsx";

/**
 * Export data to Excel file
 * @param {Array<Object>} data - Array of objects (JSON)
 * @param {string} fileName - Name of the Excel file (without .xlsx)
 * @param {string} sheetName - Optional sheet name
 */
export const exportExcel = (data, fileName = "export", sheetName = "Sheet1") => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    console.error("No data provided for Excel export.");
    return;
  }

  try {
    // Convert JSON to worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    // Write and download Excel file
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  } catch (error) {
    console.error("Failed to export Excel:", error);
  }
};
